import PropTypes from 'prop-types';
import React from 'react';
import { MyCarsButtons } from 'wsm-mycars-buttons';
import { MyCarsCtas } from 'wsm-mycars-ctas';
import { useFlags, usePrefs, useLabels } from 'wsm-common-data';

const MyCars = ({ isTabbedLayout, uuid }) => {
	const flags = useFlags();
	const { mycarsSaveLabel, mycarsSavedLabel } = usePrefs();
	const labels = useLabels();
	const modernMyCarsLabels = [
		{
			id: 'trackPrice',
			default: labels.get('TRACK_PRICE')
		},
		{
			id: 'save',
			default: labels.get(mycarsSaveLabel)
		}
	];
	const enableModernMyCars = flags['enable-modern-mycars'];
	const classNames = {
		mobileClasses: {
			container: 'w-100 justify-content-around'
		},
		commonClasses: {
			gap: 'ml-6'
		}
	};
	return (
		<>
			{enableModernMyCars ? (
				<MyCarsCtas
					uuid={uuid}
					isInLine={!isTabbedLayout}
					classNames={classNames}
					labels={modernMyCarsLabels}
				/>
			) : (
				<MyCarsButtons
					key="MyCarsButtonComponent"
					uuid={uuid}
					isLink
					{...{
						mycarsSaveLabel,
						mycarsSavedLabel
					}}
				/>
			)}
		</>
	);
};

MyCars.propTypes = {
	isTabbedLayout: PropTypes.bool.isRequired,
	uuid: PropTypes.string.isRequired
};

export default MyCars;
